import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const CUSTOM_EMAILS_MESSAGES = defineMessages({
  duplicate: { id: 'app.components.form.CustomEmails.duplicate' },
});
